import React from 'react'
import Teacher from '../components/details/teacher'

function teacher() {
  return (
    <Teacher/>
  )
}

export default teacher